import {
  TRACKING_LOADING,
  TRACKING_ERROR,
  TRACKING_FINISHED,
} from '../types/TrackingTypes';
import { SET_PRODUCTS } from '../types/ProductTypes';
import { callGetTracking } from '../../services/TrackingService';

export const setProducts = (products) => {
  return {
    type: SET_PRODUCTS,
    products,
  };
};

export const errorInGetTracking = () => {
  return {
    type: TRACKING_ERROR,
  };
};

export const loadTracking = () => {
  return {
    type: TRACKING_LOADING,
  };
};

export const finishedTracking = () => {
  return {
    type: TRACKING_FINISHED,
  };
};

export const getTracking = (order) => {
  return async (dispatch, getState) => {
    const { products } = getState().productReducer;
    try {
      dispatch(loadTracking());
      const res = await callGetTracking(order);
      if (res.status !== 200) {
        const productsWithTracking = mergeErrorTrackingWithProducts(
          products,
          order,
        );
        dispatch(setProducts(productsWithTracking));
        dispatch(finishedTracking());
        dispatch(errorInGetTracking());
      } else {
        const productsWithTracking = mergeTrackingWithProducts(
          products,
          res.data,
        );
        dispatch(setProducts(productsWithTracking));
        dispatch(finishedTracking());
      }
    } catch (err) {
      const productsWithTracking = mergeErrorTrackingWithProducts(
        products,
        order,
      );
      dispatch(setProducts(productsWithTracking));
      dispatch(finishedTracking());
      dispatch(errorInGetTracking());
    }
  };
};

const mergeTrackingWithProducts = (products, tracking) => {
  const productsWithTracking = [];
  const productsInTrackingWithDispatch = [];
  const orderId = tracking.order_id;
  const productsInTracking = products.filter(
    (product) => Number(product.orderId) === Number(orderId),
  );

  tracking.dispatches.forEach((dispatch) => {
    dispatch.dispatch_state_history.reverse();
  });

  productsInTracking.forEach((product) => {
    tracking.dispatches.forEach((dispatch) => {
      dispatch.lines.forEach((line) => {
        if (line.sku === product.sku) {
          product.dispatch = dispatch;
          productsInTrackingWithDispatch.push(product);
        }
      });
    });
  });

  products.forEach((product) => {
    const result = productsInTrackingWithDispatch.filter(
      (productWithDispatch) =>
        productWithDispatch.sku === product.sku &&
        Number(productWithDispatch.orderId) === Number(product.orderId),
    );
    if (result.length) {
      product = result[0];
      productsWithTracking.push(product);
    } else {
      productsWithTracking.push(product);
    }
  });

  return productsWithTracking;
};

const mergeErrorTrackingWithProducts = (products, orderId) => {
  return products.map((product) => {
    if (Number(product.orderId) === Number(orderId)) {
      return {
        ...product,
        errorTracking: true,
      };
    }
    return product;
  });
};
